import { useCallback, useState } from 'react'

/**
 * Estado espelhado em localStorage. Usado para lembrar que o usuário fechou a
 * tarja de promoção e que já viu o popup "Como concorrer".
 */
export function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key)
      return raw === null ? initialValue : (JSON.parse(raw) as T)
    } catch {
      return initialValue
    }
  })

  const update = useCallback(
    (next: T) => {
      setValue(next)
      try {
        localStorage.setItem(key, JSON.stringify(next))
      } catch {
        /* storage bloqueado: mantém só em memória */
      }
    },
    [key],
  )

  return [value, update] as const
}
